"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.formatPrice = formatPrice;
exports.getCurrency = getCurrency;
exports.parsePrice = parsePrice;

var _currencies = _interopRequireDefault(require("./data/currencies.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DEFAULT_CURRENCY_CODE = "USD";
/**
 * Get the currency.
 * @param {string} currencyCode The currency code to get the currency.
 * @returns {object} The currency.
 */

function getCurrency(currencyCode) {
  if (currencyCode) {
    return _currencies["default"].find(function (c) {
      return c.code === currencyCode.toUpperCase();
    }) || null;
  }

  return null;
}
/**
 * Get the formatted price.
 * @param {number} value The value to format.
 * @param {string} currencyCode The currency code to format the price. Default: USD
 * @param {boolean} showDecimal Whether to show the price's decimal part. Default: false
 * @param {boolean} showCurrencySymbol Whether to show the price's currency symbol. Default: false
 * @param {boolean} showCurrencyCode Whether to show the price's currency code. Default: false
 * @returns {string} The formatted price.
 */


function formatPrice(value) {
  var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CURRENCY_CODE;
  var showDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var showCurrencySymbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var showCurrencyCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var showSignBeforeCurrencySymbol = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (isNaN(value) || value === null) {
    return null;
  }

  var currency = getCurrency(currencyCode) || getCurrency(DEFAULT_CURRENCY_CODE);
  var number = showDecimal ? value.toFixed(2) : Math.ceil(value);
  var formattedNumberArray = number.toString().split(".");
  var formattedNumberIntegerPart = formattedNumberArray[0].replace(/\d(?=(?:\d{3}){1,4}(?!\d))/g, "$&".concat(currency.thousandsSeparator));
  var formattedNumberDecimalPart = formattedNumberArray.length > 1 ? "".concat(currency.decimalSeparator).concat(formattedNumberArray[1]) : "";
  var price = "".concat(formattedNumberIntegerPart).concat(formattedNumberDecimalPart); // handle negative numbers

  var sign = "";

  if (showSignBeforeCurrencySymbol && price.startsWith("-")) {
    price = price.substring(1);
    sign = "-";
  }

  if (showCurrencySymbol) {
    price = currency.symbolOnLeft ? "".concat(currency.symbol).concat(price) : "".concat(price).concat(currency.symbol);
  }

  if (showCurrencyCode) {
    price += " ".concat(currency.code);
  }

  price = "".concat(sign).concat(price);
  return price;
}
/**
 * Extracts the numeric value from a formatted price
 * @param {string} value - The formatted amount to parse
 * @param {string} currencyCode - The currency code to interpret the price formatting. Default: USD
 * @returns {number} The numeric value of the price. Returns NaN if parsing fails or invalid input
 */


function parsePrice(value, currencyCode) {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value !== "string") {
    return NaN;
  }

  var currency = getCurrency(currencyCode) || getCurrency(DEFAULT_CURRENCY_CODE);
  var normalizedValue = value.replaceAll(currency.thousandsSeparator, "").replaceAll(currency.code, "").replaceAll(currency.symbol, "").replaceAll(currency.decimalSeparator, ".").trim();
  return parseFloat(normalizedValue);
}

var _default = {
  formatPrice: formatPrice,
  parsePrice: parsePrice,
  getCurrency: getCurrency
};
exports["default"] = _default;